import * as React from "react";
import { Show, SimpleShowLayout, TextField } from 'react-admin';
const CategoryListDetail = ({...props }) => (

    <Show title="Category Detail" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" label="Category Name" />
            <TextField source="status" label="Status" />
            <TextField source="amount" label="Amount" />
            <TextField source="descripton" label="Description" />
        </SimpleShowLayout>
    </Show>
     );
export default CategoryListDetail